import React from "react";
import CKEditor from "react-ckeditor-component-4";

const CKeditorComponent = (props) => {
    const { content, onChange, isMetric = false, width, height, disabled = false, readOnly = false } = props;
    const isReadOnly = Boolean(disabled || readOnly);
    const config = {
        width: width ? width : "840px",
        height: height ? height : "500px",
        versionCheck: false,
        extraPlugins: "embed,autoembed,videodetector",
        embed_provider: "//ckeditor.iframe.ly/api/oembed?url={url}&callback={callback}",
        // autoEmbed_widget: "embed",
        extraAllowedContent: "iframe[*];div(*)",
        allowedContent: true,
        removePlugins: "easyimage, cloudservices",
        toolbar: [
            {
                name: "basicstyles",
                items: [
                    "Undo",
                    "Redo",
                    "-",
                    "Bold",
                    "Italic",
                    "Underline",
                    "Strike",
                    "-",
                    "Cut",
                    "Copy",
                    "-",
                    "JustifyLeft",
                    "JustifyCenter",
                    "JustifyRight",
                    "JustifyBlock",
                    "-",
                    "Subscript",
                    "Superscript",
                    "-",
                    "RemoveFormat",
                ],
            },
            { name: "colors", items: ["TextColor", "BGColor"] },
            "/",
            { name: "styles", items: ["Styles", "Format", "Font", "FontSize"] },
            {
                name: "paragraph",
                items: ["NumberedList", "BulletedList", "-", "Outdent", "Indent"],
            },
            { name: "editing", items: ["Find", "Replace", "-", "SelectAll"] },
            { name: "links", items: ["Link", "Unlink"] },
            { name: "tools", items: ["iframe", "Maximize", "Preview", "Smiley", "SpecialChar", "Embed"] },
            (isMetric == true) && "/",
            (isMetric == true) && { name: "insert", items: ["VideoDetector"] },
        ].filter(Boolean),
        readOnly: isReadOnly,
    };

    return (
        <>
            <CKEditor
                key={`ckeditor-${isReadOnly ? "readonly" : "editable"}`}
                activeClass={`p10 ${props.className ? props.className : ""}`}
                isScriptLoaded={false}
                scriptUrl={props?.scriptUrl ? props.scriptUrl : "../../ckeditor/ckeditor.js"}
                config={props.config ? props.config : config}
                content={content}
                events={{
                    change: onChange,
                    instanceReady: (evt) => {
                        evt.editor.setReadOnly(isReadOnly);
                    },
                    focus: (evt) => {
                        if (window.CKEDITOR) {
                            window.CKEDITOR.activeInstance = evt.editor;
                        }
                    },
                }}
            />
        </>
    );
};

/** CKeditor Modal View Component */
export const CKeditorModalComponent = (props) => {
    const { readOnly = false, isMetric = false } = props;
    props = {
        ...props,
        config: {
            width: "405px",
            height: "400px",
            versionCheck: false,
            extraPlugins: "embed,autoembed,videodetector",
            embed_provider: "//ckeditor.iframe.ly/api/oembed?url={url}&callback={callback}",
            // autoEmbed_widget: "embed",
            extraAllowedContent: "iframe[*]",
            allowedContent: true,
            removePlugins: "iframe, easyimage, cloudservices",
            toolbar: [
                {
                    name: "basicstyles",
                    items: [
                        "Undo",
                        "Redo",
                        "-",
                        "Bold",
                        "Italic",
                        "Underline",
                        "Strike",
                        "-",
                        "Cut",
                        "Copy",
                        "-",
                        "JustifyLeft",
                        "JustifyCenter",
                        "JustifyRight",
                        "JustifyBlock",
                        "-",
                        "RemoveFormat",
                    ],
                },
                "/",
                { name: "colors", items: ["Subscript", "Superscript", "-", "TextColor", "BGColor"] },
                {
                    name: "paragraph",
                    items: ["NumberedList", "BulletedList", "-", "Outdent", "Indent"],
                },
                { name: "editing", items: ["Find", "Replace", "-", "SelectAll"] },
                "/",
                { name: "links", items: ["Link", "Unlink"] },
                { name: "tools", items: ["Smiley", "SpecialChar", "-", "Maximize", "Preview", "Embed"] },
                isMetric == true && "/",
                isMetric == true && { name: "insert", items: ["VideoDetector"] },
            ],
            readOnly: readOnly,
        },
    };
    return <CKeditorComponent {...props}></CKeditorComponent>;
};
export default CKeditorComponent;
